'use strict';

var $ = require('jquery');
var util = require('../utils/util');
var progress = require('../utils/progress');
var $pdpMain = $('#pdpMain');
var $productSet = $('#product-set-list');
var $setItems = $('.product-set-item');
const {updateAddToCartButtonState} = require('../pages/product/addToCart');
const optiExperiment = require('../components/optimizelyExperimentation');

let isExperimentActive;

import {debounce, throttle} from '../components/custom-lodash';

function isMobileOrTablet() {
    return $(window).width() <= 1023;
}

function stickyAddToBagMobile() {
    var $addToCartSticky = $pdpMain.find('.sticky-add-to-bag');
    var addToCartPanel = document.querySelector(isExperimentActive ? '#add-to-cart' : '#panelTabsContainerDesktop');
    var footer = document.querySelector('.footer');

    var isAddToCartInViewport = util.elementInViewport(addToCartPanel);
    var isFooterReached = util.elementInViewport(footer);

    const backToTopBtn = $('.half-page-scrolled .back-to-top');
    const liveChatBtn = $('#ebcss-chat-button');
    const $liveagentButton = $('#liveagent-wrapper a');
    const hasBackToTopButton =
        $('.half-page-scrolled #liveagent-wrapper').length && $('.half-page-scrolled #liveagent-wrapper').length > 0;

    updateAddToCartButtonState(true);

    if (isAddToCartInViewport || isFooterReached) {
        $addToCartSticky.addClass('hidden');
        backToTopBtn.removeClass('add-to-cart-visible');

        if (hasBackToTopButton) {
            $liveagentButton.css('bottom', '115px');
        } else {
            $liveagentButton.css('bottom', '75px');
        }

        if (liveChatBtn) {
            liveChatBtn.removeClass('add-to-cart-visible');
        }
    } else {
        $addToCartSticky.removeClass('hidden');
        backToTopBtn.addClass('add-to-cart-visible');

        if (hasBackToTopButton) {
            $liveagentButton.css('bottom', '135px');
        } else {
            $liveagentButton.css('bottom', '75px');
        }

        if (liveChatBtn) {
            liveChatBtn.addClass('add-to-cart-visible');
        }
    }
}

module.exports = {
    init: async function () {
        var isMobileOrIsTablet = isMobileOrTablet();

        const result = await optiExperiment.decideFeatureFlagVariation('pdp');
        isExperimentActive = !$productSet.length && result.variationKeyMobileStickyAddToCart === 'treatment_1';

        if (isExperimentActive) {
            $('body').on('verifyShippingOptions', function () {
                if ($('.btn-bopis.selected').length === 0) {
                    var variationList = $('.variations-main-list').offset().top - 50;
                    window.scrollTo(0, variationList);
                }
            });
        }

        if (isMobileOrIsTablet) {
            stickyAddToBagMobile();
        }

        $(window).on(
            'scroll',
            throttle(function (e) {
                if (isMobileOrIsTablet) {
                    stickyAddToBagMobile();
                }
            }, 200)
        );

        $(window).on(
            'resize',
            debounce(function (e) {
                isMobileOrIsTablet = isMobileOrTablet();
                if (isMobileOrIsTablet) {
                    stickyAddToBagMobile();
                }
            }, 100)
        );

        $('.sticky-add-to-bag')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                const $notValidSetItem = $setItems
                    .filter((index, element) => $(element).find('.add-to-cart-disabled').length != 0)
                    .first();
                if ($('#add-to-cart').hasClass('add-to-cart-disabled')) {
                    if ($('.variations-main-list').length > 0) {
                        var variationList = $('.variations-main-list').offset().top - 50;
                        window.scrollTo(0, variationList);
                    }
                    progress.hide();
                } else if ($notValidSetItem.length) {
                    if ($notValidSetItem.find('.variations-main-list').length > 0) {
                        var variationList = $notValidSetItem.find('.variations-main-list').offset().top - 50;
                        window.scrollTo(0, variationList);
                    }
                    progress.hide();
                } else {
                    if ($productSet.length) {
                        $('#add-all-to-cart').click();
                    } else {
                        $('#add-to-cart').click();
                    }
                }
            });
    }
};
